import * as React from "react";
import { FaTimes } from "react-icons/fa";
import styled, { StyledComponent, DefaultTheme } from "styled-components";
import colors from "../../../styles/colors";
import ClickableElement from "../ClickableElement";

const ModalBackground = styled.div`
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: grid;
  place-items: center;
  background-color: #0000009e;
  position: fixed;
  z-index: 1000;
  cursor: pointer;
`;

export const ModalCard = styled.div`
  position: relative;
  max-width: 70%;
  max-height: 70%;
  z-index: 1002;
`;

const ModalContent = styled.div`
  background-color: #fff;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1), 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  border-radius: 1rem;
  height: 100%;
  position: relative;
`;

export const ModalHeader = styled.div`
  padding: 2rem 1rem;
  display: flex;
  height: 4rem;
`;
const ModalTitle = styled.h2<{ type: ModalType }>(
  ({ type }) => `
  padding-left: 2rem;
  color: ${customColor(type)};
  justify-content: flex-start;
  width: 80%;`
);
const ExitButtonContainer = styled.div`
  justify-content: flex-end;
  display: flex;
  width: 20%;
  cursor: default;
`;

const CloseIcon = styled(ClickableElement)`
  width: auto

  &: hover {
    color: ${({ theme }) => theme.colors.menuBlueLight};
  }
`;

export const ModalBody = styled.div`
  padding: 3rem;
  z-index: 1001;
  cursor: default;
`;

const ColorBar = styled.div<{ type: ModalType }>(
  ({ type }) => `
  height: 1rem;
  border-radius: 0 0 0.8rem 0.8rem;
  position: absolute;
  bottom: 0;
  width: 100%;
  background-color:${customColor(type)};
`
);

export enum ModalType {
  Warning = "Warning",
  Error = "Error",
  Success = "Success",
  Info = "Info",
}

interface ICustomModalProps {
  showModal: boolean;
  className?: string;
  closeModal: () => void;
  customCardProps?: React.CSSProperties;
  customBodyProps?: React.CSSProperties;
  customContainer?: StyledComponent<"div", DefaultTheme, {}, never>;
  message?: React.ReactNode;
  title?: string;
  type: ModalType;
}

const customColor = (type: ModalType) => {
  switch (type) {
    case ModalType.Success:
      return colors.greenSuccess;
    case ModalType.Error:
      return colors.red;
    case ModalType.Info:
      return colors.darkblue;
    default:
      return colors.orangeWarning;
  }
};

const CustomModal: React.FC<ICustomModalProps> = props => {
  if (!props.showModal) {
    return null;
  }

  const ModalContainer = props.customContainer ?? ModalBackground;

  const handleContainerClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (event.target === event.currentTarget) {
      props.closeModal();
    }
  };

  return (
    <ModalContainer className={props.className} onClick={handleContainerClick}>
      <ModalCard style={{ ...props.customCardProps }} data-testid="modal-card">
        <ModalContent>
          <ModalHeader>
            <ModalTitle type={props.type}>{props.title || props.type}</ModalTitle>
            <ExitButtonContainer>
              <CloseIcon onClick={props.closeModal}>
                <FaTimes />
              </CloseIcon>
            </ExitButtonContainer>
          </ModalHeader>
          <ModalBody style={{ ...props.customBodyProps }}>{props.message || props.children}</ModalBody>
        </ModalContent>
        <ColorBar type={props.type} />
      </ModalCard>
    </ModalContainer>
  );
};
export default CustomModal;
